import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { RegexHelper } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  title: string;
  error?: boolean;
  address_list: string[];
  handleDelete: Function;
}

// Description: AddressPanelComponent is a React component that displays a list of email addresses or domains.
// It includes a header with the count of addresses, and each address can be deleted by clicking a button.
// This is also for displaying any errors related to the addresses, such as invalid email formats from the csv upload.
function AddressPanelComponent(props: AllProps) {
  const { title, error, address_list, handleDelete } = props;  

  return <div className="csv-upload-table">
    <header className="pt-2 pb-2">
        <h5 className="m-0">{`${address_list.length} ${title}`}</h5>
    </header>
    {address_list.map((address: string, index: number) => {
        return <Row key={index}>
            <Col>
                <Icon className={`${error ? "ficon-x-circle" : RegexHelper.testEmailAddress(address) ? "ficon-user" : "ficon-globe"} me-1 text-muted`} />
                <span className={error ? "invalid" : ""}>{address}</span>
            </Col>
            <Col xs="auto" className="ms-auto" onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}>
            <Button
                className="ms-auto"
                variant="icon"
                size="sm"
                onClick={() => handleDelete(address)}
                aria-label="Delete Address or Domain"
            ><Icon className="ficon-x" /></Button>
            </Col>
        </Row>;
    })}
   </div>;
};

export default React.memo(AddressPanelComponent);
